<!--
 * @Author: Merlin
 * @Date: 2024-04-04 13:19:05
 * @LastEditors: Merlin
 * @LastEditTime: 2024-04-05 14:09:31
 * @Description: 
-->

<template>
    <div>
        <cardList
            :aRoundList="history.round"
            :oGameInfo="history"
            type="history"
        ></cardList>
    </div>
</template>

<script lang="ts" >
export default defineComponent({name: 'HiloContent'});
</script>

<script lang="ts" setup>
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';
import cardList from '@/pages/casino/hiloGame/_components/card-list.vue';

const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        required: true,
    },
});


</script>

<style scoped lang="scss">
.game-result{
    margin: 30px 0 20px;
    padding: 0 0 15px;
}
</style>


